import type { ReactNode } from 'react';

/**
 * Filtro em botoes retos separados (faixa de idade, ficha usada...). Diferente
 * de `OpcoesRadio`, que e um campo de formulario com os botoes colados, aqui
 * cada opcao e um botao alternavel e o conteudo pode ter contagem ou data.
 */
export function Seletor<V extends string | null>({
  rotulo,
  opcoes,
  valor,
  onMudar,
}: {
  rotulo: string;
  opcoes: readonly { valor: V; conteudo: ReactNode }[];
  valor: V | undefined;
  onMudar: (v: V) => void;
}) {
  return (
    <div role="group" aria-label={rotulo} className="flex flex-wrap gap-1">
      {opcoes.map((o) => {
        const ativa = o.valor === valor;
        return (
          <button
            key={o.valor ?? '∅'}
            type="button"
            aria-pressed={ativa}
            onClick={() => onMudar(o.valor)}
            className={`rounded-(--radius-controle) border px-2.5 text-[13px] font-medium transition-colors ${
              ativa ? 'border-marca bg-marca text-sobre-marca' : 'border-borda-forte text-apagado hover:text-texto'
            }`}
          >
            {o.conteudo}
          </button>
        );
      })}
    </div>
  );
}
